import React from "react";
import { FileUpload } from "primereact/fileupload";
import "./FileUploader.scss";
import { t } from "i18next";
import { ALLOWED_FILES_EXTENSION } from "src/resources/constant";

type FileUploaderProps = {
  onChange: (e: any) => void;
  fileName: string;
  id: string;
  name: string;
  accept?: string;
  disabled?: boolean;
  className?: string;
  fileUploadRef:any
};
const FileUploader = ({
  onChange,
  fileName,
  id,
  name,
  accept,
  disabled,
  className,
  fileUploadRef = null
}: FileUploaderProps) => {
  const chooseOptions = {
    label: t("selectFile"),
    className: "input-group-text",
    icon: "null",
  };
  const uploadOptions = { className: "d-none" };
  const cancelOptions = { className: "d-none" };

  return (
    <div className="file-field-container">
      <FileUpload
        ref={fileUploadRef}
        id={id}
        name={name}
        disabled={disabled}
        className={className}
        emptyTemplate={fileName || t("selectFile")}
        auto
        onSelect={onChange}
        onUpload={() => { }}
        accept={accept ? accept : ALLOWED_FILES_EXTENSION}
        chooseOptions={chooseOptions}
        uploadOptions={uploadOptions}
        cancelOptions={cancelOptions}
        customUpload={true}
      />
    </div>
  );
};

export default FileUploader;
